export default {
  status: {
    processing: false,
    error: null,
    success: null,
    previous: null
  },
  sampleMessages: [],
  sampleSubscription: null
}
